import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { SORT_KEYS } from '@utils/documentVault';
import { DocumentVaultFilterContext } from '@/contexts/DocumentVaultFilterContext';
import { DocumentVaultSelectionContext } from '@/contexts/DocumentVaultSelectionContext';
import { SelectionCheckbox } from '../selection/SelectionCheckbox';
import { CellWrapper, HeaderRowWrapper } from './styles';

const SortableHeader = styled.span`
  cursor: pointer;
  user-select: none;

  * {
    color: ${({ theme, $isActive }) => ($isActive ? theme.themeColors.primaryCtaButton : theme.themeColors.text)};
  }
`;

const COLUMNS = [
  { key: SORT_KEYS.filename, label: 'Name' },
  { key: SORT_KEYS.docType, label: 'Type' },
  { key: SORT_KEYS.company, label: 'Company' },
  { key: SORT_KEYS.uploaded, label: 'Uploaded' },
  { key: null, label: 'Status' },
  { key: null, label: '' },
];

export const VaultTableHeader = ({ pageDocs = [] }) => {
  const { filters, setSort } = React.useContext(DocumentVaultFilterContext);
  const { isSelected, setPageSelection } = React.useContext(DocumentVaultSelectionContext);

  const selectedOnPage = pageDocs.filter((doc) => isSelected(doc)).length;
  const isPageFullySelected = pageDocs.length > 0 && selectedOnPage === pageDocs.length;
  // Partial selection reads as mixed, so the header never claims more than it has.
  const isPagePartiallySelected = selectedOnPage > 0 && !isPageFullySelected;

  return (
    <HeaderRowWrapper>
      <CellWrapper>
        <SelectionCheckbox
          isChecked={isPageFullySelected}
          isIndeterminate={isPagePartiallySelected}
          onChange={(shouldSelect) => setPageSelection(pageDocs, shouldSelect)}
          ariaLabel="Select all on this page"
        />
      </CellWrapper>
      {COLUMNS.map((column, index) => {
        if (!column.key) {
          return (
            <CellWrapper key={column.label || `spacer-${index}`}>
              <Body5 bold isLowContrast>
                {column.label}
              </Body5>
            </CellWrapper>
          );
        }

        const isActive = filters.sort.key === column.key;
        return (
          <CellWrapper key={column.key}>
            <SortableHeader $isActive={isActive} onClick={() => setSort(column.key)}>
              <Body5 bold>
                {column.label}
                {isActive ? (filters.sort.direction === 'asc' ? ' ↑' : ' ↓') : ''}
              </Body5>
            </SortableHeader>
          </CellWrapper>
        );
      })}
    </HeaderRowWrapper>
  );
};
